import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    navigationError: false,
    user: null,
    aws_user: null,
    permissions: [],
    loading: false,
    organization: {
      name: ""
    },
    initialize: false,
    enterprise: "unloaded",
    pricingRefresh: 0,
    needauth: false
  },
  mutations: {
    /**
     *
     * @param {*} state
     * @param {Boolean} isloading
     */
    setLoading(state, isloading) {
      state.loading = Boolean(isloading);
    },
    setNavigationError(state, navigationError) {
      state.navigationError = Boolean(navigationError);
      state.loading = Boolean(false);
    },
    setOrganization(state, organization) {
      state.organization = organization;
    },
    setUser(state, user) {
      state.user = user;
    },
    setAWSUser(state, user) {
      state.aws_user = user;
    },
    setInitialize(state, value) {
      state.initialize = Boolean(value);
    },
    enterprise(state, value) {
      state.enterprise = value;
    },
    pricingRefresh(state, value) {
      state.pricingRefresh = value;
    },
    needauth(state, value) {
      state.needauth = Boolean(value);
    }
  },
  getters: {
    enterprise: state => state.enterprise,
    isLoading: state => state.loading,
    isInitialized: state => state.initialize,
    getOrganization: state => state.organization,
    getAWSUser: state => state.aws_user,
    getUser: state => state.user || { permissions: [] },
    navigationError: state => state.navigationError,
    pricingRefresh: state => state.pricingRefresh,
    needauth: state => state.needauth
  }
});
